import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { ENTER } from '@angular/cdk/keycodes';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';

@Component({
    selector: 'app-lob-add-popup',
    templateUrl: './lob-add-popup.component.html',
    styleUrls: ['./lob-add-popup.component.css'],
    standalone: false
})
export class LobAddPopupComponent implements OnInit {

  segments = ['Optum', 'UHC', 'UHG', 'Other'];
  newLobClicked = false;
  @Input() dataSource;
  @Input() filteredData;
  @Input() isNewClicked;
  @Input() isSubLobEditClicked;
  @Input() EditColumnDataSubLob;
  @Input() isLobEditClicked;
  @Input() EditColumnDataLob;
  @Output() AddLobDataEmitter : EventEmitter<any> = new EventEmitter();
  @Output() EditLobDataEmitter : EventEmitter<any> = new EventEmitter();
  @Output() EditSubLobDataEmitter : EventEmitter<any> = new EventEmitter();
  @Output() clearSearch:EventEmitter<any> = new EventEmitter();

  destroy$: ReplaySubject<boolean> = new ReplaySubject(1);

  segmentData = [];
  lobData = [];
  segmentSelected: string = '';
  lobSelected : string = '';
  lobNameEntered: string = '';
  subLobDescription:string = '';
  subLobEntered:string = '';
  LobDescription:string = '';
  private subject: Subject<string> = new Subject();
  inputElement: any;
  selectedArchitects = [];
  selectedDelegates = [];
  users:any = [];
  architectsSegment:any = [];
  architectDel:any = [];
  chiefArchitects: any = [];
  subLobEnteredEdit: string = '';
  separatorKeysCodes: number[] = [ENTER];
  addLobData: any;
  EditLobFinal = {
    "lob_id": '',
    "cio_lob": {
      isChanged: false,
      value: ''
    },
    "LOB_description": {
      isChanged: false,
      value: ''
    }
  };
  EditSubLobFinal = {
    "lob_id": '',
    "SubLobID": '',
    'SubLineofBusiness': {
      isChanged: false,
      value: ''
    },
    'Sub_LOB_description': {
      isChanged: false,
      value: null
    },
    'add': [],
    'remove': [],
    'addCA': [],
    'addAD': [],
    'removeCA': [],
    'removeAD': [],
    'leadsToUpdateCA':[],
    'leadsToUpdateAD':[]

  };
  AddLobDataUpdated = {
    "lob_id": "",
    "cio_lob": null,
    "SegId": "",
    "master_segment": null,
    "sub_lob": "",
    "LOB_description": null,
    "Sub_LOB_description": null,
    'lobNameEntered': '',
    'ChiefArchitect': [],
    'ArchitectDelegate': [],
    'master_segment_name': '',
    'cio_lob_name': ''
  };
  disableEditLob: boolean = true;
  disableAddLob: boolean = true;
  disableEditSubLob: boolean = true;
  @Input() resetpopupData;
  @ViewChild('inputAddChiefArch') inputAddChiefArch: any;
  @ViewChild('inputAddArchDel') inputAddArchDel: any;
  @ViewChild('inputEditChiefArch') inputEditChiefArch: any;
  @ViewChild('inputEditArchDel') inputEditArchDel: any;
  chiefArchitectEditSubLob: any = [];
  architectDelegateEditSubLob: any = [];
  TABLE_COLUMNS: any = [
    {
      matColumnDef: 'select',
      key: 'select',
      labelKey: "",
      label: ''
    },
    {
      key: 'displayName',
      labelKey: "displayName",
      label: 'Name',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'mail',
      labelKey: "mail",
      label: 'E-mail',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'leadEA',
      labelKey: "leadEA",
      label: 'Lead',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }],
      padding: '5px 15px 5px 5px !important'
    },
    {
      key: 'Actions',
      labelKey: "Actions",
      label: '',
      filter: false,
      align: 'center',
      search: '',
      searchValue: '',
      width: '1% !important',
      edit: false,
      validations: [{ 'required': false }],
    }

  ]
  TABLE_CONFIG: any = {
    pageSize: [5, 10, 15],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    TABLE_CLASS : 'scroll-table-container'
  };
  
  


  constructor(
    public dialog : MatDialog,
    private capabilityService: CommonModelService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
    

    
  }
  ngOnChanges(){
    if (this.isNewClicked){
      this.loadAddLobData();
    }
    if (this.isSubLobEditClicked){
      this.LoadEditSubLobData();
    }
    if (this.isLobEditClicked){
      this.loadEditLobData();
    }    
  }

  loadAddLobData(){
    const segmentsVar = [];
    this.segmentData = [];
    this.dataSource.filter(seg => {
      if (segmentsVar.includes(seg.MasterSegment) == false){
        this.segmentData.push({'segment': seg.MasterSegment, 'segmentId': seg.SegID});
        segmentsVar.push(seg.MasterSegment);
      }
    });
  }
  loadEditLobData(){
    this.EditLobFinal.cio_lob.value = this.EditColumnDataLob.CIOLOB;
    if (!this.EditColumnDataLob.LOB_description){
      this.EditColumnDataLob.LOB_description = '';
    }
    this.EditLobFinal.LOB_description.value = this.EditColumnDataLob.LOB_description;

  }

  LoadEditSubLobData(){
    this.EditSubLobFinal.lob_id = this.EditColumnDataSubLob.LobID;
    this.EditSubLobFinal.SubLobID = this.EditColumnDataSubLob.SubLobID;
    this.EditSubLobFinal.SubLineofBusiness.value = this.EditColumnDataSubLob.SubLineofBusiness;
    if (!this.EditColumnDataSubLob.Sub_LOB_description){
      this.EditColumnDataSubLob.Sub_LOB_description = '';
    }
    this.EditSubLobFinal.Sub_LOB_description.value = this.EditColumnDataSubLob.Sub_LOB_description;
    this.EditColumnDataSubLob.ChiefArchitect.forEach(architect => {
      this.chiefArchitectEditSubLob.push(architect);
    });
    this.EditColumnDataSubLob.ArchitectDelegate.forEach(architect => {
      this.architectDelegateEditSubLob.push(architect);
    });
  }
  newLob(){
    this.newLobClicked = !this.newLobClicked;
    this.AddLobDataUpdated.lobNameEntered = '';
    this.AddLobDataUpdated.cio_lob = '';
    this.AddLobDataUpdated.LOB_description = '';
    this.disableApplyAddLob();
  }
  getNewMappedLob(seg){
    this.lobData = this.dataSource.filter(element => {
        if (element.MasterSegment === seg.value.segment && element.SegID === seg.value.segmentId){
          return element;
        } 
      });
    this.AddLobDataUpdated.cio_lob = '';
    this.AddLobDataUpdated.LOB_description = '';
    this.disableApplyAddLob();
  }

  lobChange(lob){
    this.dataSource.filter(row => {
      if (row.LobID === lob.value.LobID){
        this.AddLobDataUpdated.LOB_description = row.LOB_description;
      }
    })
    this.disableApplyAddLob();
  }


  removeLobArchitects(user, role) {
    if (role === 'Architect'){
      const index = this.AddLobDataUpdated.ChiefArchitect.indexOf(user);
      if (index >= 0) {
        this.AddLobDataUpdated.ChiefArchitect.splice(index, 1);
      }
    }
    else {
      const index = this.AddLobDataUpdated.ArchitectDelegate.indexOf(user);
      if (index >= 0) {
        this.AddLobDataUpdated.ArchitectDelegate.splice(index, 1);
      }
    }    
  }

  keyUpSearch(name) {
    const p: any = {}
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    }
    else{
      this.users = [];
    }
  }
  AddLobArchitects(event, role) {
    if(event.option.value.givenName !== '') {
      if (role === 'Architect'){
        this.AddLobDataUpdated.ChiefArchitect.push(event.option.value);
      }
      else if(role === 'Delegate') {
        this.AddLobDataUpdated.ArchitectDelegate.push(event.option.value);
      }
    }
    if (this.inputElement) {
      this.inputElement.target.value = '';
      this.users = []
    }    
  }

  checkexistArchitects(user, type, actionType) {
    let tempVar = [];
    
    if (actionType === 'Add'){
      if (type === 'Architect'){
        tempVar = this.AddLobDataUpdated.ChiefArchitect;
      }
      else{
        tempVar = this.AddLobDataUpdated.ArchitectDelegate;
      }
    }
    else {
      if (type === 'Architect'){
        tempVar = this.chiefArchitectEditSubLob;
      }
      else{
        tempVar = this.architectDelegateEditSubLob;
      }
    }
    let tempBool = false
    tempVar.forEach(archi => {
      if (user.MSId === archi.msid || user.MSId === archi.MSId){
        tempBool = true;
      }
      
    });
    return tempBool;
  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
          dataStream.forEach(element => {
            this.users.push({ 
              givenName: element.givenName, 
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              MSId: element.cn,
              middleName: element.middleName,
            });
          });
      }, (error) => {
        console.error(error);
       });
    } else {
      column.options = [];
    }
  }

  AddSubLobArchitects(architect, role){
    if (role === 'Delegate'){
      this.architectDelegateEditSubLob.push(architect.option.value);
      architect.option.value.role = 'Architect Delegate';
    }
    else {
      this.chiefArchitectEditSubLob.push(architect.option.value);
      architect.option.value.role = 'Chief Architect';
    }
    let existFlag = false;
    this.EditSubLobFinal.remove.forEach(row => {
      if (architect.option.value.MSId === row.MSId && architect.option.value.role === row.role){
        const index = this.EditSubLobFinal.remove.indexOf(row);
        if (index >= 0) {
          this.EditSubLobFinal.remove.splice(index, 1);
          existFlag = true;
        }
      }
    })
    if (!existFlag){
      this.EditSubLobFinal.add.push(architect.option.value);
    }

    if (this.inputElement) {
        this.inputElement.target.value = '';
        this.users = []
    }
    this.disableApplyEditSubLob();
  }

  removeSubLobArchitects(architect, role){
    if (role === 'Delegate'){
      const index = this.architectDelegateEditSubLob.indexOf(architect);
      if (index >= 0) {
        this.architectDelegateEditSubLob.splice(index, 1);
      }
      architect.role = 'Architect Delegate';
    }
    else{
      const index = this.chiefArchitectEditSubLob.indexOf(architect);
      if (index >= 0) {
        this.chiefArchitectEditSubLob.splice(index, 1);
      }
      architect.role = 'Chief Architect';
    }
    let existFlag = false;
    this.EditSubLobFinal.add.forEach(row => {
      if (architect.MSId === row.MSId && architect.role === row.role){
        const index = this.EditSubLobFinal.add.indexOf(row);
        if (index >= 0) {
          this.EditSubLobFinal.add.splice(index, 1);
          existFlag = true;
        }
      }
    });
    if (!existFlag){
      this.EditSubLobFinal.remove.push({
        'employeeID' : architect.employeeID,
        'MSId' : architect.msid || architect.MSId,
        'role' : architect.role
      });
    }
    this.disableApplyEditSubLob();
  }

  applyAdd(){
    this.AddLobDataUpdated.lob_id = this.AddLobDataUpdated.cio_lob.LobID;
    this.AddLobDataUpdated.SegId = this.AddLobDataUpdated.master_segment.segmentId;
    this.AddLobDataUpdated.cio_lob_name = this.AddLobDataUpdated.cio_lob.CIOLOB;
    this.AddLobDataUpdated.master_segment_name = this.AddLobDataUpdated.master_segment.segment;
    this.AddLobDataEmitter.emit(this.AddLobDataUpdated);    
  }

  applyEditSubLob(){
    this.EditSubLobFinal.Sub_LOB_description.value = this.EditSubLobFinal.Sub_LOB_description.value.trim();
    this.EditSubLobFinal.SubLineofBusiness.value = this.EditSubLobFinal.SubLineofBusiness.value.trim();

    if (this.EditColumnDataSubLob?.SubLineofBusiness !== this.EditSubLobFinal.SubLineofBusiness.value){
      this.EditSubLobFinal.SubLineofBusiness.isChanged = true;
    }
    else{
      this.EditSubLobFinal.SubLineofBusiness.isChanged = false;
    }
    if (this.EditColumnDataSubLob?.Sub_LOB_description !== this.EditSubLobFinal.Sub_LOB_description.value){
      this.EditSubLobFinal.Sub_LOB_description.isChanged = true;
    }
    else{
      this.EditSubLobFinal.Sub_LOB_description.isChanged = false;
    }
    if (this.EditSubLobFinal.SubLineofBusiness.value !== ''){
      this.EditSubLobDataEmitter.emit(this.EditSubLobFinal);
    }
    else{
      this.toastrService.error('Invalid Sub LOB Name', '', {
        timeOut: 5000,
        positionClass: 'toast-top-center'
      });
    }
    this.clearSearch.emit('');
  }

  applyEditLob(){
    this.EditLobFinal.LOB_description.value = this.EditLobFinal.LOB_description.value.trim();
    this.EditLobFinal.cio_lob.value = this.EditLobFinal.cio_lob.value.trim();

    if (this.EditColumnDataLob.CIOLOB !== this.EditLobFinal.cio_lob.value){
      this.EditLobFinal.cio_lob.isChanged = true;
    }
    else{
      this.EditLobFinal.cio_lob.isChanged = false;
    }
    if (this.EditColumnDataLob.LOB_description !== this.EditLobFinal.LOB_description.value){
      this.EditLobFinal.LOB_description.isChanged = true;
    }
    else{
      this.EditLobFinal.LOB_description.isChanged = false;
    }
    this.EditLobFinal.lob_id = this.EditColumnDataLob.LobID;
    if (this.EditLobFinal.cio_lob.value !== ''){
      this.EditLobDataEmitter.emit(this.EditLobFinal);
    }
    else{
      this.toastrService.error('Invalid LOB Name', '', {
        timeOut: 5000,
        positionClass: 'toast-top-center'
      });
    }
}
disableApplyLob(){
  if (this.EditLobFinal.cio_lob.value.trim() !== this.EditColumnDataLob.CIOLOB){
    this.disableEditLob = false;
  }
  else if (this.EditLobFinal.LOB_description.value.trim() != this.EditColumnDataLob.LOB_description){
    this.disableEditLob = false;
  }
  else{
    this.disableEditLob = true;
  }
}

disableApplyAddLob(){
  if (this.AddLobDataUpdated.master_segment && 
    (this.AddLobDataUpdated.cio_lob || this.AddLobDataUpdated.lobNameEntered.trim()) && 
    this.AddLobDataUpdated.sub_lob.trim()){

      this.disableAddLob = false;
  }
  else{
    this.disableAddLob = true;
  }

}

disableApplyEditSubLob(){
  this.disableEditSubLob = !(
    this.EditColumnDataSubLob.SubLineofBusiness !== this.EditSubLobFinal.SubLineofBusiness.value.trim() ||
    this.EditColumnDataSubLob.Sub_LOB_description !== this.EditSubLobFinal.Sub_LOB_description.value.trim() ||
    this.EditSubLobFinal.addCA.length > 0 || this.EditSubLobFinal.removeCA.length > 0 || this.EditSubLobFinal.leadsToUpdateCA.length > 0 ||
    this.EditSubLobFinal.addAD.length > 0 || this.EditSubLobFinal.removeAD.length > 0 || this.EditSubLobFinal.leadsToUpdateAD.length > 0
  );
  }

  focusOnInput(type){
    if (type === 'addChiefArch'){
      this.inputAddChiefArch.nativeElement.focus();
    }
    else if (type === 'addArchDel'){
      this.inputAddArchDel.nativeElement.focus();
    }
    else if (type === 'editChiefArch'){
      this.inputEditChiefArch.nativeElement.focus();
    }
    else {
      this.inputEditArchDel.nativeElement.focus();
    }
  }

  addUpdatedValueForArchitectDelegate(ev){
    this.AddLobDataUpdated.ArchitectDelegate = ev.addUsers.length > 0 ? ev.addUsers : [];
  }

  addUpdatedValueForChiefArchitect(ev){
    this.AddLobDataUpdated.ChiefArchitect = ev.addUsers.length > 0 ? ev.addUsers : [];
  }

  //When user clicks on Apply button
  onSubmit(isEdit: boolean = false) {
    const subTitleMsg = this.generateSubTitleMessage(isEdit);
    const dialogConfig = this.configureDialog(subTitleMsg, isEdit);
    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data === 'save') {
        isEdit ? this.applyEditSubLob() : this.applyAdd();
      }
    });
  }

  //Get the subtitle message for the dialog
  private generateSubTitleMessage(isEdit: boolean): string {
    if (isEdit) {
      return `<p class="dialog-text text-left">Chief Architect Added - ${this.EditSubLobFinal.addCA.length}</p>` +
        `<p class="dialog-message">Architect Delegate Added - ${this.EditSubLobFinal.addAD.length}</p>` +
        `<p class="dialog-message">Chief Architect Removed - ${this.EditSubLobFinal.removeCA.length}</p>` +
        `<p class="dialog-message">Architect Delegate Removed - ${this.EditSubLobFinal.removeAD.length}</p>` +
        `<p class="dialog-message">Chief Architect Lead Updated - ${this.EditSubLobFinal.leadsToUpdateCA.length}</p>` +
        `<p class="dialog-message">Architect Delegate Lead Updated - ${this.EditSubLobFinal.leadsToUpdateAD.length}</p>`;
    } else {
      return `<p class="dialog-text">Chief Architect Added - ${this.AddLobDataUpdated.ChiefArchitect.length}</p>` +
        `<p class="dialog-message">Architect Delegate Added - ${this.AddLobDataUpdated.ArchitectDelegate.length}</p>`;
    }
  }

  //Configure the dialog
  private configureDialog(subTitleMsg: string, isEdit: boolean): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'auto !important';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.height = 'auto';
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = "capability-dialog";
    dialogConfig.maxWidth = '600px !important';
    dialogConfig.data = {
      subTitle: subTitleMsg.replace('\\n/g', '<br/>'),
      buttonName: 'Continue',
      title: isEdit ? 'Update Confirmation!' : 'Add Confirmation!'
    };
    return dialogConfig;
  }

  getUpdatedValueForChiefArchitect(ev){
    this.EditSubLobFinal.addCA = ev.addUsers.length > 0 ? ev.addUsers : [];
    this.EditSubLobFinal.removeCA = ev.removeUsers.length > 0 ? ev.removeUsers : [];
    this.EditSubLobFinal.leadsToUpdateCA = ev.statusUpdatedUsers.length > 0 ? ev.statusUpdatedUsers : [];
    this.disableApplyEditSubLob();
  }

  getUpdatedValueForArchitectDelegate(ev){
    this.EditSubLobFinal.addAD = ev.addUsers.length > 0 ? ev.addUsers : [];
    this.EditSubLobFinal.removeAD = ev.removeUsers.length > 0 ? ev.removeUsers : [];
    this.EditSubLobFinal.leadsToUpdateAD = ev.statusUpdatedUsers.length > 0 ? ev.statusUpdatedUsers : [];
    this.disableApplyEditSubLob();
  }
}